/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Cli_Save_Settings_LabelInputs */



/**
* | output |
* | --- |
* | "Save CLI tool settings" |
*
* @param {Options_Cli_Save_Settings_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_cli_save_settings_label = /** @type {((inputs?: Options_Cli_Save_Settings_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Cli_Save_Settings_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Enregistrer les paramètres des outils CLI")
	if (locale === "de") return /** @type {LocalizedString} */ ("CLI-Tool-Einstellungen speichern")
	if (locale === "it") return /** @type {LocalizedString} */ ("Salva le impostazioni dello strumento CLI")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Сохранение настроек инструмента командной строки")
	if (locale === "es") return /** @type {LocalizedString} */ ("Guardar la configuración de la herramienta CLI")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("保存 CLI 工具设置")
	if (locale === "ja") return /** @type {LocalizedString} */ ("CLIツールの設定を保存する")
	if (locale === "hi") return /** @type {LocalizedString} */ ("CLI टूल सेटिंग्स सहेजें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Salvar configurações da ferramenta CLI")
	return /** @type {LocalizedString} */ ("Save CLI tool settings")
});